module.exports = __webpack_public_path__ + "static/media/icon-restart.af2a8013.svg";